/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOEncryptionDTO } from '../models/ApiResponseDTOEncryptionDTO';
import type { ApiResponseDTOListUserInfoDTO } from '../models/ApiResponseDTOListUserInfoDTO';
import type { ApiResponseDTOOnboardingMetadataResponseDTO } from '../models/ApiResponseDTOOnboardingMetadataResponseDTO';
import type { ApiResponseDTOOTPResponseDTO } from '../models/ApiResponseDTOOTPResponseDTO';
import type { ApiResponseDTOOTPVerifyDTO } from '../models/ApiResponseDTOOTPVerifyDTO';
import type { ApiResponseDTOPhoneNumberAccountLookupResponseDTO } from '../models/ApiResponseDTOPhoneNumberAccountLookupResponseDTO';
import type { ApiResponseDTOSubmitUtilityVerificationResponseDTO } from '../models/ApiResponseDTOSubmitUtilityVerificationResponseDTO';
import type { ApiResponseDTOUtilityVerificationStatusResponseDTO } from '../models/ApiResponseDTOUtilityVerificationStatusResponseDTO';
import type { ApiResponseDTOValidationFieldResponseDTO } from '../models/ApiResponseDTOValidationFieldResponseDTO';
import type { ApiResponseDTOVoid } from '../models/ApiResponseDTOVoid';
import type { BulkImportPhoneNumberDTO } from '../models/BulkImportPhoneNumberDTO';
import type { EmailDTO } from '../models/EmailDTO';
import type { PhoneNumberAccountLookupRequestDTO } from '../models/PhoneNumberAccountLookupRequestDTO';
import type { SendOtpDTO } from '../models/SendOtpDTO';
import type { SubmitUtilityBvnSelfieVerifyRequestDTO } from '../models/SubmitUtilityBvnSelfieVerifyRequestDTO';
import type { UserInfoRequestDTO } from '../models/UserInfoRequestDTO';
import type { ValidationFieldRequestDTO } from '../models/ValidationFieldRequestDTO';
import type { VerifyOtpDTO } from '../models/VerifyOtpDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UtilityApiService {

    /**
     * Verify OTP
     * Verify OTP by supplying the correct token that was sent to the user
     * @param requestBody
     * @returns ApiResponseDTOOTPVerifyDTO OK
     * @throws ApiError
     */
    public static verifyOtp1(
        requestBody: VerifyOtpDTO,
    ): CancelablePromise<ApiResponseDTOOTPVerifyDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/mfa/totp/otp/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get Verification Status
     * Get verification status by jobId - works for BVN, selfie, or combined verifications
     * @param jobId
     * @returns ApiResponseDTOUtilityVerificationStatusResponseDTO OK
     * @throws ApiError
     */
    public static getVerificationStatus(
        jobId: string,
    ): CancelablePromise<ApiResponseDTOUtilityVerificationStatusResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/utility/bvn-selfie/status/{jobId}',
            path: {
                'jobId': jobId,
            },
            errors: {
                400: `Bad Request`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Submit Combined BVN & Selfie Verification
     * Submit combined BVN and selfie verification - reusable utility API for independent verification
     * @param requestBody
     * @returns ApiResponseDTOSubmitUtilityVerificationResponseDTO OK
     * @throws ApiError
     */
    public static submitBvnSelfieVerification(
        requestBody: SubmitUtilityBvnSelfieVerifyRequestDTO,
    ): CancelablePromise<ApiResponseDTOSubmitUtilityVerificationResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/utility/bvn-selfie/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get available Encryption Public Key
     * Get available Encryption Public Key
     * @param channel
     * @param xApiKey
     * @returns ApiResponseDTOEncryptionDTO OK
     * @throws ApiError
     */
    public static getPublicKey(
        channel: 'WEB' | 'MOBILE' | 'POS',
        xApiKey: string,
    ): CancelablePromise<ApiResponseDTOEncryptionDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/utility/encryption/public-key',
            headers: {
                'Channel': channel,
                'X-Api-Key': xApiKey,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get Onboarding Metadata
     * Returns dropdown config data for onboarding (source of funds, staff size, annual estimated turnover)
     * @param registrationType
     * @returns ApiResponseDTOOnboardingMetadataResponseDTO OK
     * @throws ApiError
     */
    public static getOnboardingMetadata(
        registrationType: string = 'LIMITED_LIABILITY',
    ): CancelablePromise<ApiResponseDTOOnboardingMetadataResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/utility/onboarding/metadata',
            query: {
                'registrationType': registrationType,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Send OTP
     * Send a new OTP to a user
     * @param requestBody
     * @returns ApiResponseDTOOTPResponseDTO OK
     * @throws ApiError
     */
    public static sendOtp(
        requestBody: SendOtpDTO,
    ): CancelablePromise<ApiResponseDTOOTPResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/utility/otp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Verify OTP
     * Verify OTP by supplying the correct token that was sent to the user
     * @param requestBody
     * @returns ApiResponseDTOOTPVerifyDTO OK
     * @throws ApiError
     */
    public static verifyOtp(
        requestBody: VerifyOtpDTO,
    ): CancelablePromise<ApiResponseDTOOTPVerifyDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/utility/otp/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Look up an account by phone number
     * Unauthenticated. Says whether an account is registered with the phone number and, when it is, the registration type of the business (individual, sole proprietorship, limited liability, NGO, and so on). A number with no account answers 200 with exists=false.
     * @param requestBody
     * @returns ApiResponseDTOPhoneNumberAccountLookupResponseDTO OK
     * @throws ApiError
     */
    public static lookupAccountByPhoneNumber(
        requestBody: PhoneNumberAccountLookupRequestDTO,
    ): CancelablePromise<ApiResponseDTOPhoneNumberAccountLookupResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/utility/phone-number/account-lookup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Missing or malformed phone number`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Bulk Import Profiled Phone Numbers
     * Import a list of profiled phone numbers for onboarding whitelist
     * @param requestBody
     * @returns ApiResponseDTOVoid OK
     * @throws ApiError
     */
    public static bulkImportProfiledPhoneNumbers(
        requestBody: BulkImportPhoneNumberDTO,
    ): CancelablePromise<ApiResponseDTOVoid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/utility/profiled-phone-numbers/bulk-import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Send Generic Email
     * Send Generic Email
     * @param requestBody
     * @returns ApiResponseDTOVoid OK
     * @throws ApiError
     */
    public static sendGenericEmail(
        requestBody: EmailDTO,
    ): CancelablePromise<ApiResponseDTOVoid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/utility/send-generic-email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Validate fields
     * Validates a field given its type name and value
     * @param requestBody
     * @returns ApiResponseDTOValidationFieldResponseDTO OK
     * @throws ApiError
     */
    public static validateField(
        requestBody: ValidationFieldRequestDTO,
    ): CancelablePromise<ApiResponseDTOValidationFieldResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/utility/system/field-validation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get List users accounts
     * API used to get List the users accounts
     * @param requestBody
     * @returns ApiResponseDTOListUserInfoDTO OK
     * @throws ApiError
     */
    public static getUsersInfo(
        requestBody: UserInfoRequestDTO,
    ): CancelablePromise<ApiResponseDTOListUserInfoDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/utility/users-info',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

}
